import { VersionRange } from '../../models/core/version-range.js';
import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { PhotoCollection } from '../../models/serializable/photo-collection.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class PointOfInterestComponent extends Component {
  static readonly TYPE_ID: string = 'bb168f64a58742dd8eb1d9463dcdb98e';
  static readonly SCHEMA_VERSION: number = 3;

  constructor(
    public readonly legacyProfilePhotos: PhotoCollection | null,
    public readonly isPublic: boolean = false,
  ) {
    super();
  }

  get $typeId() {
    return PointOfInterestComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  get $schemaVersion(): VersionRange {
    return VersionRange.between(1, PointOfInterestComponent.SCHEMA_VERSION);
  }

  static fromMap(context: SerializationContext, map: SerializedData): PointOfInterestComponent {
    return new PointOfInterestComponent(
        context.fromDataOrNull<PhotoCollection>(MapUtils.getOrNull<SerializedData>(map, 'profilePhotos')),
        MapUtils.get<boolean>(map, 'isPublic'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'isPublic': this.isPublic,
    };
  }

  clone(): this {
    return new PointOfInterestComponent(
        this.legacyProfilePhotos?.clone() ?? null,
        this.isPublic,
    ) as this;
  }

  isSame(other: PointOfInterestComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.legacyProfilePhotos, this.legacyProfilePhotos) &&
      other.isPublic === this.isPublic;
  }
}

export class PointOfInterestComponentBuilder extends DataModelBuilder<PointOfInterestComponent> {
  build(context: SerializationContext, map: SerializedData): PointOfInterestComponent {
    return PointOfInterestComponent.fromMap(context, map);
  }

  migrateToCurrentSchemaVersion(context: SerializationContext, map: SerializedData): SerializedData | null {
    const versionRange = MapUtils.getVersionRange(map);
    if(versionRange.contains(PointOfInterestComponent.SCHEMA_VERSION)) {
      return map;
    }

    if(versionRange.isGreaterThan(PointOfInterestComponent.SCHEMA_VERSION)) {
      return null; // This data comes from the FUTURE. We have no idea how to migrate it.
    }

    let version = versionRange.to;

    if(version < 2) {
      MapUtils.set(map, 'isPublic', false);
      version = 2;
    }

    if(version < 3) {
      version = 3;
    }

    map['$schema_version'] = VersionRange.encodedExactly(version);
    return map;
  }
}
